import { formatDate, formatTime, prettyFormatDate, formatDuration, prettyFormatDuration } from '@pjn/utils/date';
import { capitalize } from '@pjn/utils/string';
import { formatFileSize } from '@pjn/utils/file';
/**
 * Incluye filtros generales en la aplicacion.
 *
 * @param Vue Clase base de Vue
 */
export function addGeneralFilters(Vue) {
    console.debug('Se incluyen los filtros globales');
    Vue.filter('enumeration', (s) => s ? s.replace('_', ' ') : '');
    Vue.filter('date', formatDate);
    Vue.filter('prettyDate', prettyFormatDate);
    Vue.filter('dateTime', (d) => formatDate(d, { includeTime: true }));
    Vue.filter('time', formatTime);
    Vue.filter('duration', (ms) => formatDuration(ms));
    Vue.filter('prettyDuration', (ms) => prettyFormatDuration(ms));
    Vue.filter('filesize', formatFileSize);
    Vue.filter('capitalize', (value) => value ? capitalize(value.toLowerCase()).replace('Csjn', 'CSJN') : '');
}
//# sourceMappingURL=filters.js.map